import AppHeader from "../../layout/AppHeader";
import Integration from '../../xpost/views/register/integration/Integration.vue';
import IntegrationAdd from '../../xpost/views/register/integration/IntegrationAdd.vue';
import IntegrationLogs from '../../xpost/views/register/integration/IntegrationLogs.vue';

const IntegrationRoutes = [
    {
        path: "/cadastro/integracao",
        name: "integration",
        meta: {
            role: ['1', '2', '3', '5'],
        },
        components: {
            header: AppHeader,
            default: Integration
        }
    },
    {
        path: "/cadastro/integracao/adicionar",
        name: "integration.add",
        meta: {
            role: ['1', '2', '3'],
        },
        components: {
            header: AppHeader,
            default: IntegrationAdd
        }
    },
    {
        path: '/cadastro/integracao/adicionar/:id',
        name: 'integration.edit',
        meta: {
            role: ['1', '2', '3'],
        },
        components: {
            header: AppHeader,
            default: IntegrationAdd
        }
    },
    {
        path: '/cadastro/integracao/logs/:id',
        name: 'integration.logs',
        meta: {
            role: ['1', '2', '3', '5'],
        },
        components: {
            header: AppHeader,
            default: IntegrationLogs
        }
    }
]

export default IntegrationRoutes;